import { render, staticRenderFns } from "./TmDataEmpty.vue?vue&type=template&id=37799886&"
import script from "./TmDataEmpty.vue?vue&type=script&lang=js&"
export * from "./TmDataEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports